import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { CharacterSelect } from './views/CharacterSelect';

const LayoutComponent = () => {
	return (
		<Fragment>
			<Background />
			<CharacterSelect />
		</Fragment>
	);
};

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.CharacterSelect)
	.build();

export default Layout;
